import { BrowserRouter } from 'react-router-dom';
import { ContainerProvider } from '@presentation/providers/container-context';
import { AuthProvider } from '@presentation/providers/auth-context';
import { ToastProvider } from '@presentation/providers/toast-context';
import { RealtimeProvider } from '@presentation/providers/realtime-context';
import { AppRouter } from '@presentation/router/app-router';

/**
 * Composition racine : DI → session → notifications → routage.
 * Aucune logique métier ici, uniquement du câblage.
 */
export default function App(): JSX.Element {
  return (
    <ContainerProvider>
      <AuthProvider>
        <ToastProvider>
          <RealtimeProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </RealtimeProvider>
        </ToastProvider>
      </AuthProvider>
    </ContainerProvider>
  );
}
